import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import useMcpGoogleLogin from 'features/auth/hooks/useMcpGoogleLogin';
import { Button } from '@urbantxt/button';
import { ParagraphText } from '@urbantxt/paragraph-text';
import styles from 'features/auth/components/LoginForm/LoginForm.module.scss';

/**
 * OAuth login bridge for remote Bagel MCP clients.
 * Google sign-in only — staff must use a Google-linked Rosie account.
 */
function McpLoginPage() {
  const { mcpSession, mcpServerUrl, isLoading, error, signInWithGoogle } =
    useMcpGoogleLogin();

  const missingConfig = !mcpServerUrl;
  const missingSession = !mcpSession;

  return (
    <AuthCard>
      <AuthFormHeader>
        <ParagraphText marginTop={10}>
          Sign in with Google to connect Bagel MCP
        </ParagraphText>
      </AuthFormHeader>

      {missingConfig && (
        <ParagraphText color="red">
          REACT_APP_MCP_SERVER_URL is not configured on this Rosie
          deployment.
        </ParagraphText>
      )}

      {missingSession && (
        <ParagraphText color="red">
          Missing MCP session. Open this page from your MCP client
          authorization flow.
        </ParagraphText>
      )}

      {!missingConfig && !missingSession && (
        <div className={styles.authChoiceContainer}>
          {error && <ParagraphText color="red">{error}</ParagraphText>}
          <Button
            className={styles.darkGoogleButton}
            size="full"
            type="button"
            isLoading={isLoading}
            onClick={signInWithGoogle}
            startIcon={<FontAwesomeIcon color="#fff" icon={faGoogle} />}
          >
            <ParagraphText textAlign="center" margin={0} color="#fff">
              Sign in with Google
            </ParagraphText>
          </Button>
        </div>
      )}
    </AuthCard>
  );
}

export default McpLoginPage;
